import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import axiosInstance from "../../shared/service/axios";
import {
  BuySellAddResponse,
  BuySellListResponse,
  BuySellUpdateRequest,
  BuySellUpdateResponse,
} from "./BuySell.constants";

//DEVİCE

export const useBuySellAddMutation = (): UseMutationResult<
  BuySellAddResponse,
  AxiosError,
  BuySellUpdateRequest
> =>
  useMutation<BuySellAddResponse, AxiosError, BuySellUpdateRequest>(
    async (requestValues: BuySellUpdateRequest) => {
      const { data, status } = await axiosInstance.post(
        "BuySell/",
        requestValues
      );
      data.status = status;

      return data;
    }
  );

export const useBuySellUpdateMutation = (): UseMutationResult<
  BuySellUpdateResponse,
  AxiosError,
  BuySellUpdateRequest
> =>
  useMutation<BuySellUpdateResponse, AxiosError, BuySellUpdateRequest>(
    async (requestValues: BuySellUpdateRequest) => {
      const { data, status } = await axiosInstance.put(
        "BuySell/" + requestValues.id + "/",
        requestValues
      );
      data.status = status;

      return data;
    }
  );

export const useDeviceBuySellDeleteMutation = (): UseMutationResult<
  any,
  AxiosError,
  string
> =>
  useMutation<any, AxiosError, string>(async (requestValues: string) => {
    const { status } = await axiosInstance.delete(
      "device/transaction/" + requestValues + "/"
    );

    return status;
  });

export const useDeviceBuySellListMutation = (): UseMutationResult<
  BuySellListResponse,
  AxiosError,
  any
> =>
  useMutation<BuySellListResponse, AxiosError, any>(async (requestValues) => {
    if (requestValues === 0) {
      const { data, status } = await axiosInstance.get("device/transaction/");

      return data;
    } else {
      const { data, status } = await axiosInstance.get("device/transaction/", {
        params: {
          content_type: requestValues,
        },
      });

      return data;
    }
  });

//DEVİCE PART

export const useDevicePartBuySellListMutation = (): UseMutationResult<
  BuySellListResponse,
  AxiosError,
  any
> =>
  useMutation<BuySellListResponse, AxiosError, any>(async (requestValues) => {
    if (requestValues === 0) {
      const { data, status } = await axiosInstance.get(
        "device/part/transaction/"
      );

      return data;
    } else {
      const { data, status } = await axiosInstance.get(
        "device/part/transaction/",
        {
          params: {
            content_type: requestValues,
          },
        }
      );

      return data;
    }
  });
